import { BaseService } from "./BaseService";
import {
  CreateRequestCommentDto,
  RequestComment,
  RequestCommentsFilters,
  RequestCommentsFindAllResponse,
  UpdateRequestCommentDto,
} from "@/types/requestComment";
import { IRequestCommentsService } from "./interfaces/IRequestCommentsService";

class RequestCommentsService
  extends BaseService
  implements IRequestCommentsService
{
  private basePath = "/requests";

  constructor() {
    super();
  }

  async getAll(
    filters: RequestCommentsFilters,
  ): Promise<RequestCommentsFindAllResponse> {
    const { requestId, ...rest } = filters;
    return this.get<RequestCommentsFindAllResponse>(
      `${this.basePath}/${requestId}/comments`,
      rest,
    );
  }

  async getById(id: string): Promise<RequestComment> {
    return this.get<RequestComment>(`/request-comments/${id}`);
  }

  async create(data: CreateRequestCommentDto): Promise<RequestComment> {
    const { requestId, ...body } = data;
    return this.post<RequestComment>(
      `${this.basePath}/${requestId}/comments`,
      body,
    );
  }

  async update(
    id: string,
    data: UpdateRequestCommentDto,
  ): Promise<RequestComment> {
    return this.patch<RequestComment>(`/request-comments/${id}`, data);
  }

  async deleteComment(id: string): Promise<void> {
    return this.delete<void>(`/request-comments/${id}`);
  }
}

export const requestCommentsService = new RequestCommentsService();
